import { PayloadAction } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';
import { TGetConversionDraftsFeeAPIParams } from '~types/feat/gold';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';

export default function* watchGetGoldConversionDraftsFee(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetGoldConversionDraftsFeeAttempt', handleGetGoldConversionDraftsFee, api);
}

function* handleGetGoldConversionDraftsFee(api: GoldGateway, action: PayloadAction<TGetConversionDraftsFeeAPIParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { draftId, originProductId, targetProductId, quantity } = action.payload;

    const response = yield* call([api, api.getGoldConversionDraftsFee], {
        authToken,
        draftId,
        originProductId,
        targetProductId,
        quantity,
    });

    if (response.status === GatewayResponseStatus.Error) {
        toast.error(response.message || ErrorMessages.GoldCreateTransactionError);
        yield put(combinedActions.goldGetConversionDraftsFeeFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetConversionDraftsFeeSuccess(response.data));
    }
}
